module.exports = __webpack_public_path__ + "static/media/eticket.446c04ed.png";